/** Create an ordered array of {size} integers beginning with {start} and increasing by 1.  */
export const range = (size: number, start = 1) =>
    Array(size)
        .fill(1)
        .map((_v, i) => i + start)
